import React from 'react';

interface ScrollToBottomButtonProps {
    onClick: () => void;
    visible: boolean;
    className?: string;
    style?: React.CSSProperties;
}

const ScrollToBottomButton: React.FC<ScrollToBottomButtonProps> = ({
    onClick,
    visible,
    className = '',
    style = {}
}) => {
    return (
        <button
            onClick={onClick}
            className={`
        flex items-center justify-center
        w-10 h-10 rounded-full
        bg-violet-100/20 dark:bg-violet-400/20 backdrop-blur-sm
        shadow-lg border border-violet-200/30 dark:border-violet-700/30
        hover:bg-violet-100/20 dark:hover:bg-violet-400/20
        transition-all duration-300 ease-in-out
        ${visible
                    ? 'opacity-100 scale-100 pointer-events-auto'
                    : 'opacity-0 scale-90 pointer-events-none'
                }
        ${className}
      `}
            style={style}
            aria-label="Scroll to bottom"
        >
            <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="text-violet-600 dark:text-violet-300"
            >
                <path
                    d="M12 5V19M12 19L19 12M12 19L5 12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </button>
    );
};

export default ScrollToBottomButton;
